import React from 'react';
import { DonationPicker } from './DonationPicker';
import { NewsletterForm } from './NewsletterForm';
export function GetInvolved() {
  return <section id="join" className="bg-sun py-20 md:py-28" data-id="element-117" data-mp="2gluqpp0a5tej">
      <div className="mx-auto max-w-7xl px-5 md:px-8" data-id="element-118" data-mp="21q517gvvyy52">
        <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end" data-id="element-119" data-mp="21rpvr6i7ah2x">
          <div data-id="element-120" data-mp="26qjcr8wp4q7u">
            <p className="font-script text-4xl text-flamingo" data-id="element-121" data-mp="1sx1t7o40fdht">Únete al movimiento</p>
            <h2 className="mt-2 font-display text-6xl uppercase leading-[0.9] text-ink md:text-8xl" data-id="element-122" data-mp="1suytudgyw80f">
              Join the familia
            </h2>
          </div>
          <p className="max-w-sm text-lg text-ink/80" data-id="element-123" data-mp="1j06up57qld3j">
            Your support keeps Honduran culture thriving in L.A. and opens doors for the next generation.
          </p>
        </div>

        <div className="mt-12 grid gap-5 lg:grid-cols-12" data-id="element-124" data-mp="19z8ocg9tsths">
          <div className="lg:col-span-7" data-id="element-125" data-mp="1dzriwi33sdno">
            <DonationPicker data-id="element-126" data-mp="1dypw5gcq62q4" />
          </div>
          <div className="lg:col-span-5" data-id="element-127" data-mp="1e1lv980b6xg5">
            <NewsletterForm data-id="element-128" data-mp="2gitfqv7as1ip" />
          </div>
        </div>
      </div>
    </section>;
}